module.exports = "/_next/static/images/waterAndSewageSystemPipelineFacilities-02a67bcceccda15b66dd5959c2de5c55.webp";